// 高级搜索组件slot所需自定义特殊组件

export default {
  install: (Vue, options) => {
    Vue.component("el-invoiceMoney-range", {
      props: {
        name: {
          type: String
        },
        value: {
          type: Array
        }
      },
      data() {
        return {
          priceStart: "",
          priceEnd: ""
        };
      },
      watch: {
        value(newValue) {
          this.priceStart = newValue[0];
          this.priceEnd = newValue[1];
        }
      },
      methods: {
        formatPrice(type) {
          this[type] += "";
          if (this[type].charAt(0) == ".") {
            // 截取字符串
            this[type] = "";
          }
          console.log(this[type], "type");
          this[type] = this[type].replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
          this[type] = this[type].replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
          this[type] = this[type]
            .replace(".", "$#$")
            .replace(/\./g, "")
            .replace("$#$", ".");
          this[type] = this[type].replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
          if (this[type].indexOf(".") <= 0 && this[type] != "") {
            //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
            this[type] = parseFloat(this[type]);
          }
          // this[type] = this[type].toString();
          // this[type] = this[type].toFixed(2);
        },
        handleChange() {
          console.log(this.priceStart, this.priceEnd);
          if (this.priceStart)
            this.priceStart = Number(this.priceStart).toFixed(2);
          if (this.priceEnd) this.priceEnd = Number(this.priceEnd).toFixed(2);

          this.$emit("input", [this.priceStart, this.priceEnd]);
        }
      },
      template: `
        <div class="ccui-price-range">
        <el-input
            @input="formatPrice('priceStart')"
            @change="handleChange"
            placeholder="请输入最小金额"
            clearable
            style="width:45%"
            v-model.trim="priceStart">
        </el-input>
        <span>至</span>
        <el-input
            @input="formatPrice('priceEnd')"
            @change="handleChange"
            placeholder="请输入最大金额"
            clearable
            style="width:45%"
            v-model.trim="priceEnd">
        </el-input>
        </div>
      `
    });
  }
};
